import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IqacsubheadingListComponent } from './iqacsubheading-list/iqacsubheading-list.component';
import { IqacsubheadingCreateComponent } from './iqacsubheading-create/iqacsubheading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: IqacsubheadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: IqacsubheadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'iqac-subheading-create/:id',
        component: IqacsubheadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IqacSubHeadingRoutingModule { }
